module.exports = __webpack_public_path__ + "img/122.239f3ce0.jpg";